import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: {
    id: 'frontbucket.dashboard.repositories.searchFilter',
    description: 'Placeholder for search filter',
    defaultMessage: 'Search repositories',
  },
});
